import { clsx } from 'clsx'
import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconMail } from '@redteclab/icons'

import styles from './MediServiceFurtherInformation.module.css'

type MediServiceFurtherInformationEmailProps = {
  overrideContactEmail?: ReactNode
}

export const MediServiceFurtherInformationEmail: FC<
  MediServiceFurtherInformationEmailProps
> = ({ overrideContactEmail }) => {
  return (
    <div
      className={clsx(styles['further-information-contact-details-section'])}
    >
      <IconMail className="size-6 text-dark-brand" />
      <div className={styles.description}>
        <span>
          <FormattedMessage id="chrx.further-info.email-title" />
        </span>
        <span className="text-dark-primary-strong">
          {overrideContactEmail ?? (
            <FormattedMessage id="chrx.further-info.email.new" />
          )}
        </span>
      </div>
    </div>
  )
}
